export const receipt = {
  "loading": "กำลังโหลดใบเสร็จ...",
  "order": "คำสั่งซื้อ:",
  "date": "วันที่:",
  "customer": "ลูกค้า:",
  "item": "รายการ",
  "qty": "จำนวน",
  "total": "รวม",
  "subtotal": "ยอดรวม",
  "discount": "ส่วนลด",
  "tax": "ภาษี (7%)",
  "totalAmount": "ยอดสุทธิ",
  "thankYou": "ขอบคุณที่ใช้บริการ!",
  "notFound": "ไม่พบคำสั่งซื้อ"
};
